__turbopack_context__.v({
  "star": "PortalReviewRating-module__e7yBhG__star",
  "starFill": "PortalReviewRating-module__e7yBhG__starFill",
  "stars": "PortalReviewRating-module__e7yBhG__stars",
});
